export default {
  pagination: {},
  providers: [],
  events: [],
  typeCommands: [],
  typeEvents: [],
  kajabiList: [],
  kajabiIntegration: {},
  integrationList: [],
  tags: [],
  integration: "",
  mapProviderName: {
    active_campaign: "Active Campaign",
    leadlovers: "Lead Lovers",
    rdstation: "RD Station",
    lead_lovers: "Lead Lovers"
  },
  coproducerProducts: [],
  all_zoom_integrations: []
};
